import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Ul = ({
  children,
  gutterBottom,
}: {
  children: React.ReactNode;
  gutterBottom?: boolean;
}) => (
  <Box
    component="ul"
    marginTop={0}
    marginBottom={gutterBottom ? 1 : 0}
    paddingInlineStart={6}
  >
    {children}
  </Box>
);

export const Ol = ({
  children,
  gutterBottom,
}: {
  children: React.ReactNode;
  gutterBottom?: boolean;
}) => (
  <Box
    component="ol"
    marginTop={0}
    marginBottom={gutterBottom ? 1 : 0}
    paddingInlineStart={6}
  >
    {children}
  </Box>
);

export const Li = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Typography component="li">{children}</Typography>
);
